import React from "react";
import PropTypes from "prop-types";
import { Document, Page, View, Link, Text, Image, Font } from "@react-pdf/renderer";
import LogoLinewize from "./LogoLinewize";
import LogoSmoothwallGreen from "./LogoSmoothwallGreen";
import styles from "./PDFSnapshotStyles";

Font.register({
	family: "Roboto",
	fonts: [
		{ src: "https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Me5Q.ttf" },
		{
			src: "https://fonts.gstatic.com/s/roboto/v29/KFOlCnqEu92Fr1MmWUlvAw.ttf",
			fontWeight: "bold",
		},
	],
});

const DeviceDetailsItem = ({ title, detail }) => (
	<View style={styles.deviceDetailItem}>
		<Text style={styles.deviceDetailItemText}>
			<Text style={{ fontWeight: "bold" }}>{title}: </Text>
			{detail}
		</Text>
	</View>
);
DeviceDetailsItem.propTypes = {
	title: PropTypes.string.isRequired,
	detail: PropTypes.string.isRequired,
};

const defaultPdfLabels = {
	screenshotTaken: "Screenshot taken",
	device: "Device",
	teacher: "Teacher",
	class: "Class",
	mac: "MAC address",
	pageNum: "Page 1/1",
};

const LiveViewReport = (props) => {
	const labels = { ...defaultPdfLabels, ...props.pdfLabels };
	return (
		<Document title={props.filename} author="Classwize" creator="Classwize">
			<Page orientation="landscape" style={styles.main} wrap={false}>
				<View style={styles.header}>
					<View>
						<Text style={styles.title}>
							{props.studentName} ({props.studentUsername}) | {props.deviceName}
						</Text>
						<Link src={props.url} style={styles.linkStyle}>
							{props.url}
						</Link>
					</View>
					{
						<View style={props.smoothwall ? styles.headerLogoSmoothwall : styles.headerLogo}>
							{props.smoothwall ? <LogoSmoothwallGreen /> : <LogoLinewize />}
						</View>
					}
				</View>
				<View style={styles.imageContainer}>
					<Link src={props.url}>
						<Image style={styles.screenshot} src={props.image} />
					</Link>
				</View>
				<View style={styles.footer}>
					<View style={styles.deviceDetails}>
						<DeviceDetailsItem title={labels.screenshotTaken} detail={props.timestamp} />
						{props.platform && <DeviceDetailsItem title={labels.device} detail={props.platform} />}
						{props.teacher && <DeviceDetailsItem title={labels.teacher} detail={props.teacher} />}
						{props.class && <DeviceDetailsItem title={labels.class} detail={props.class} />}
						{props.mac && <DeviceDetailsItem title={labels.mac} detail={props.mac} />}
					</View>
					<View style={styles.footerRight}>
						<Text style={styles.timestamp}>{props.timestamp}</Text>
						<Text style={styles.pageNum}>{labels.pageNum}</Text>
					</View>
				</View>
			</Page>
		</Document>
	);
};

LiveViewReport.propTypes = {
	filename: PropTypes.string,
	image: PropTypes.string.isRequired,
	url: PropTypes.string,
	studentName: PropTypes.string.isRequired,
	studentUsername: PropTypes.string.isRequired,
	deviceName: PropTypes.string.isRequired,
	timestamp: PropTypes.string.isRequired,
	mac: PropTypes.string,
	class: PropTypes.string,
	teacher: PropTypes.string,
	platform: PropTypes.string,
	smoothwall: PropTypes.bool,
	pdfLabels: PropTypes.shape({
		screenshotTaken: PropTypes.string,
		device: PropTypes.string,
		teacher: PropTypes.string,
		class: PropTypes.string,
		mac: PropTypes.string,
		pageNum: PropTypes.string,
	}),
};

export default LiveViewReport;
